import React, { useCallback, useContext, useState } from 'react';
import MuroIcon from '@wix/da-ds/pkg/Icons/MuroCommentIcon';
import { ButtonProps } from './types';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
import Headerless from '@wix/da-ds/pkg/modals/dsPresets/HeaderlessModal/HeaderlessModal';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

const X_RESET_TIME = 1000;

const MuroComment: React.FC<ButtonProps> = ({
  editor,
  hideWhenNotEnabled = true,
}) => {
  const { t } = useTranslation('editor');
  const isMobile = useContext(MobileContext);

  const [showMuroPopup, setShowMuroPopup] = useState<boolean>(false);
  const hideMuroPopup = useCallback(() => {
    setShowMuroPopup(false);
  }, [setShowMuroPopup]);

  const openMuroModal = useCallback(() => {
    setShowMuroPopup(true);
  }, [setShowMuroPopup]);

  const useDrawing = useCallback(
    (deviation: PapiDeviation) => {
      editor.commands.daMuroUseDrawing(deviation);
    },
    [editor]
  );
  const [closeRequested, setCloseRequested] = useState(false);
  const doClose = useCallback(() => {
    hideMuroPopup();
  }, [hideMuroPopup]);

  const handleClose = useCallback(() => {
    setCloseRequested(true);

    // This timeout is to "reset" the x button, so if the close gets cancelled the
    // user can try to close again later
    setTimeout(() => {
      setCloseRequested(false);
    }, X_RESET_TIME);
  }, [setCloseRequested]);

  if (!editor?.storage?.['da-ext-renderers']?.muroMicro) {
    return null;
  }
  const Micro = editor.storage['da-ext-renderers'].muroMicro;
  const MobileMuro = editor.storage['da-ext-renderers'].muroMobile;

  return (
    <>
      <EditorIconButton
        featureId="node:micromuro"
        tooltipText={t('button.micromuro.tooltip')}
        aria-label={t('button.micromuro.tooltip')}
        icon={MuroIcon as any}
        onClick={openMuroModal}
      />
      {showMuroPopup && !isMobile && (
        <Headerless
          useFixedMobileHeight
          isOpen={true}
          hasCloseButton
          onRequestClose={handleClose}
        >
          <Micro
            handleUseDrawing={useDrawing}
            onRequestClose={doClose}
            closeRequested={closeRequested}
          ></Micro>
        </Headerless>
      )}
      {showMuroPopup && isMobile && (
        <Headerless
          useFixedMobileHeight
          isOpen={true}
          hasCloseButton
          onRequestClose={handleClose}
        >
          <MobileMuro
            handleUseDrawing={useDrawing}
            onRequestClose={doClose}
            closeRequested={closeRequested}
          ></MobileMuro>
        </Headerless>
      )}
    </>
  );
};
MuroComment.displayName = 'MuroComment';

export default MuroComment;
